import { render, staticRenderFns } from "./BannerNotificationForm.vue?vue&type=template&id=140acf0e&"
import script from "./BannerNotificationForm.vue?vue&type=script&lang=js&"
export * from "./BannerNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerNotificationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports